import React, { useState, useEffect } from "react";
import { Image } from "antd";

import styles from "./index.module.css";
import LOGO from "../../assets/logo_blacktext.png";
import BLACK_LOGO from "../../assets/logo_whitetext.png";
import {
  GiftOutlined,
  UserOutlined,
  EnvironmentOutlined,
  SearchOutlined,
  SoundOutlined,
} from "@ant-design/icons";

export default function PreviewBackdrop({
  backdropSrc,
  bannerSrc,
  bannerData,
  colour1 = "#FFF0F2",
  colour2 = "#FF4C64",
  iconColour = "#000000",
  contentType = "image/png",
}) {
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const checkTheme = () => {
      const theme = document.documentElement.getAttribute("data-theme");
      setIsDarkMode(theme === "dark");
    };

    checkTheme();

    const observer = new MutationObserver(checkTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["data-theme"],
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className={styles.mobilePreview}>
      {/* Mobile Preview Indicator */}
      <div className={styles.previewTitle}>Mobile App Preview</div>

      {/* Mobile Phone Frame */}
      <div className={styles.phoneFrame}>
        {/* Header + Search Section - Merged with single gradient */}
        <div
          className={styles.headerSearchContainer}
          style={{
            background: `linear-gradient(180deg, ${colour1} 0%, ${colour2} 100%)`,
          }}
        >
          {/* Header with Location and Icons */}
          <div className={styles.mobileHeader}>
            <div className={styles.locationSection}>
              <EnvironmentOutlined
                className={styles.locationIcon}
                style={{ color: iconColour }}
              />
              <div className={styles.locationInfo}>
                <span
                  className={styles.deliveryTime}
                  style={{ color: iconColour }}
                >
                  8 mins
                </span>
                <span
                  className={styles.locationText}
                  style={{ color: iconColour }}
                >
                  Hiranandani, Thane
                </span>
              </div>
            </div>
            <div className={styles.headerActions}>
              <GiftOutlined
                className={styles.headerIcon}
                style={{ color: iconColour }}
              />
              <UserOutlined
                className={styles.headerIcon}
                style={{ color: iconColour }}
              />
            </div>
          </div>

          {/* Search Bar with Daily Deals */}
          <div className={styles.searchSection}>
          <div className={styles.searchRow}>
            <div className={styles.searchBar}>
              <SearchOutlined
                className={styles.searchIcon}
                style={{ color: iconColour }}
              />
              <span
                className={styles.searchPlaceholder}
                style={{ color: iconColour }}
              >
                Search for products...
              </span>
              <SoundOutlined
                className={styles.voiceIcon}
                style={{ color: iconColour }}
              />
            </div>
            <div className={styles.dailyDeals}>
              <span
                className={styles.dailyDealsPercent}
                style={{ color: iconColour }}
              >
                %
              </span>
              <span
                className={styles.dailyDealsText}
                style={{ color: iconColour }}
              >
                DAILY
                <br />
                DEALS
              </span>
            </div>
          </div>
          </div>
        </div>

        {/* Backdrop Image Section */}
        {backdropSrc ? (
          <div className={styles.backdropSection}>
            {contentType?.startsWith('video') ? (
              <video
                className={styles.backdropImage}
                src={backdropSrc}
                autoPlay
                muted
                loop
                playsInline
                style={{
                  width: '390px',
                  height: '120px',
                  objectFit: 'cover',
                  display: 'block'
                }}
              />
            ) : (
              <Image
                className={styles.backdropImage}
                src={backdropSrc}
                alt="Backdrop"
                preview={false}
              />
            )}
          </div>
        ) : (
          <div className={styles.backdropSection}>
            <div className={styles.backdropPlaceholder}>
              <div className={styles.placeholderText}>
                Upload backdrop image
                <br />
                (390 x 120 pixels)
              </div>
            </div>
          </div>
        )}

        {/* Banner Section */}
        {(bannerSrc || bannerData?.banner_image) ? (
          <div className={styles.bannerSection} style={{ backgroundColor: colour2 }}>
            <div className={styles.bannerInner}>
              <Image
                className={styles.bannerImage}
                src={bannerSrc || bannerData?.banner_image}
                alt="Banner"
                preview={false}
                fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNk+M9QDwADhgGAWjR9awAAAABJRU5ErkJggg=="
              />
            </div>
          </div>
        ) : (
          <div className={styles.bannerSection} style={{ backgroundColor: colour2 }}>
            <div className={styles.bannerPlaceholder} style={{ backgroundColor: '#ffffff', border: '2px dashed #d9d9d9' }}>
              <div className={styles.placeholderText} style={{ color: '#999' }}>
                Select banner
                <br />
                (358 x 170 pixels)
              </div>
            </div>
          </div>
        )}

        {/* Category Section */}
        <div className={styles.categorySection}>
          <h3 className={styles.categoryHeading}>Grocery & kitchen</h3>
          <div className={styles.categoryGrid}>
            {Array.from({ length: 8 }, (_, i) => (
              <div key={i} className={styles.categoryCard}>
                <div className={styles.categoryIcon}></div>
                <div className={styles.categoryTextGroup}>
                  <div className={styles.categoryName}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
